import { FunctionComponent, useEffect } from "react";

import DicomHeadersModal from "@src/modules/DicomViewer/DicomHeadersModal";
import { DicomViewerWrapper } from "@src/modules/DicomViewer/ViewerWrapper/ViewerWrapper.components";
import useModal from "@src/modules/shared/components/Modal/useModal";

const ViewerWrapper: FunctionComponent = ({ children }) => {
  const { openFixedModal } = useModal();

  useEffect(() => {
    const handler = (e: Event) => {
      const { detail } = e as CustomEvent<{ s3Url: string }>;
      openFixedModal(<DicomHeadersModal s3Url={detail.s3Url} />);
    };

    addEventListener("REQUEST_HEADERS", handler);
    return () => removeEventListener("REQUEST_HEADERS", handler);
  });

  return <DicomViewerWrapper panelStyle="light">{children}</DicomViewerWrapper>;
};

export default ViewerWrapper;
